
import { createApiCall } from 'services'
import { ActionCallback } from 'store/model'
import { ActionType } from 'store/users/types'
import type { GetUsersPayload, GetUsersResponse } from 'store/users/types'

import { call, put, fork, takeLatest } from 'redux-saga/effects'



export function* getUsersSaga(): Generator {
  yield takeLatest(ActionType.GET_USERS, function* (action: ActionCallback<GetUsersPayload>) {
    const { payload, callback } = action

    try {
      const response: GetUsersResponse = yield call(createApiCall, {
        method: 'GET',
        url: `/admins/admin/platform-supervisors`,
        params: payload,
      })

      const { status, data } = response

      if (status === 200) {
        yield put({
          type: ActionType.SET_USERS,
          payload: data,
        })
      }

      if (callback) callback()
    } catch (error) {
      console.error(error)
    }
  })
}

export default [fork(getUsersSaga)]
